import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BookingService } from './services/booking.service';
import { ContractsService } from './services/contracts.service';
import { ConvertPhotoService } from './services/convert.photo.service';
import { ErrorService } from './services/error.service';
import { GatingServices } from './services/gating.services';
import { GuestService } from './services/guest.service';
import { OexpensesService } from './services/oexpenses.service';
import { OExpensesUtils } from './services/oexpenses.utils';
import { OlciUtils } from '../../effects/olcieffects.utils';
import { ResourceBundleService } from './services/resource-bundle.service';
import { MockingService } from './services/response-mock.service';
import { UserMenuComponent } from './user-menu/user-menu.component';
import { RclExcaliburModule } from '@rccl/rcl-excalibur';
import { CommonModule } from '@angular/common';
import { GuestCheckinCompletedComponent } from './guest-checkin-completed/guest-checkin-completed.component';
import { GuestListComponent } from './guest-list/guest-list.component';
import { ErrorWrapperComponent } from './error-wrapper/error-wrapper.component';
import { ErrorWrapperInnerComponent } from './error-wrapper/error-wrapper-inner.component';
import { CapitalizeFirstLetter } from '../../pipes/capitalizefirstletter.pipe';
import { CapitalizeFirstLetterAllWords } from '../../pipes/capitalizefirlstletterallwords.pipe';
import { DateSuffix } from '../../pipes/datesuffix.pipe';
import { EmailComponent } from './email/email.component';
import { EmailFormComponent } from './email-form/email-form.component';
import { UrlServiceFactory } from '../../services/url.service.factory';
import { GuestDetailsService } from './services/guest-details.service';
import { FeatureFlagsService } from './services/feature-flags.service';
import { LoaderService } from '../loading/loader.service';
import { MicroServicesService } from './services/micro-services.service';
import { BoardingPassService } from './services/boarding-pass.service';
import { RouterModule } from '@angular/router';
import { AnalyticsService } from './services/analytics.services';
import {RequestManagerService} from './services/request-manager.service';
import { MainNavMessageCenterComponent } from 'src/app/components/main-nav-message-center/main-nav-message-center.component'

@NgModule({
	imports: [RouterModule, RclExcaliburModule, CommonModule],
	exports: [
		RouterModule,
		UserMenuComponent,
		GuestCheckinCompletedComponent,
		GuestListComponent,
		ErrorWrapperComponent,
		ErrorWrapperInnerComponent,
		CapitalizeFirstLetter,
		CapitalizeFirstLetterAllWords,
		DateSuffix,
		EmailComponent,
		EmailFormComponent,
    MainNavMessageCenterComponent
	],
	declarations: [
		UserMenuComponent,
    MainNavMessageCenterComponent,
		GuestCheckinCompletedComponent,
		GuestListComponent,
		ErrorWrapperComponent,
		ErrorWrapperInnerComponent,
		CapitalizeFirstLetter,
		CapitalizeFirstLetterAllWords,
		DateSuffix,
		EmailComponent,
		EmailFormComponent
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CoreModule {
	static forRoot() {
		return {
			ngModule: CoreModule,
			providers: [
				BookingService,
				ContractsService,
				ConvertPhotoService,
				ErrorService,
				GatingServices,
				GuestService,
				OexpensesService,
				MicroServicesService,
				GuestDetailsService,
				ResourceBundleService,
				MockingService,
				FeatureFlagsService,
				LoaderService,
				BoardingPassService,
				AnalyticsService,
				OlciUtils,
				OExpensesUtils,
        RequestManagerService,
				{
					provide: 'UrlService',
					useFactory: UrlServiceFactory,
					deps: []
				}
			]
		};
	}
}
